
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "Instrutor",
        components: {    },  
    }) 
    export default class Instrutor extends Vue {
         
    }
  
